import BaseModel from '@/app-core/lib/data/model/BaseModel'
import CheckoutPaymentValidator from '@/app-core/api/validations/checkout/CheckoutPaymentValidator'
import CheckoutPaymentResource from '@/app-core/api/resources/checkout/CheckoutPaymentResource'

export default class CheckoutPaymentModel extends BaseModel {
  constructor(payload = {}, resource = CheckoutPaymentResource, validator = CheckoutPaymentValidator) {
    super(payload, resource, validator)
  }

  boot() {
    super.boot()

    this.guarded = []
  }

  /* PROPERTIES */

  /* METHODS */
}
